module.exports = __webpack_public_path__ + "static/media/template-4.50c517eb.svg";